<div class="group flex items-center gap-1">
  <h2 class="!m-0 text-xl font-bold" [id]="anchor()">{{ heading() }}</h2>

  <button
    type="button"
    mat-icon-button
    class="icon-xs opacity-0 transition-opacity focus-visible:opacity-100 group-hover:opacity-100"
    [attr.aria-label]="copyLabel()"
    [matTooltip]="copyLabel()"
    (click)="copyLink()"
  >
    <mat-icon class="icon-xs">link</mat-icon>
  </button>
</div>
